/**
 * Formats a phone number for display
 * @param {string} phone - The phone number to format
 * @returns {string} - Formatted phone number or 'N/A' if invalid
 */
export const formatPhoneNumber = (phone) => {
    if (!phone) return 'N/A';

    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, '');

    // Check if it's a US number (10 or 11 digits)
    if (cleaned.length === 10) {
        // Format as (123) 456-7890
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
        // Format as +1 (123) 456-7890
        return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    } else if (cleaned.length === 11) {
        // Format as +1 (123) 456-7890
        return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
    } else if (cleaned.length > 0) {
        // For other lengths, return the cleaned version
        return cleaned;
    } else {
        return 'N/A';
    }
};
